import ProveedorCrud from './ProveedorCrud'
export {ProveedorCrud}
export default ProveedorCrud
